const MAX_FILE_BYTES = 2 * 1024 * 1024;

function validateFile(bytes, claimedType, name) {
  if (!(bytes instanceof Uint8Array) || !bytes.length || bytes.length > MAX_FILE_BYTES) {
    throw Object.assign(new Error('파일은 0바이트보다 크고 2MB 이하여야 합니다.'), { code: 'VALIDATION_ERROR' });
  }
  const prefix = Array.from(bytes.slice(0, 12));
  const ascii = String.fromCharCode(...bytes.slice(0, 1024));
  let mime;
  if (prefix.slice(0, 8).join(',') === '137,80,78,71,13,10,26,10') mime = 'image/png';
  else if (prefix[0] === 255 && prefix[1] === 216 && prefix[2] === 255) mime = 'image/jpeg';
  else if (ascii.startsWith('%PDF-')) {
    const pdfText = new TextDecoder('latin1').decode(bytes);
    if (/\/(?:JavaScript|JS|Launch|EmbeddedFile|RichMedia|XFA)\b/i.test(pdfText)) {
      throw Object.assign(new Error('스크립트 또는 내장 실행 파일이 있는 PDF는 허용하지 않습니다.'), { code: 'VALIDATION_ERROR' });
    }
    mime = 'application/pdf';
  } else {
    let text;
    try { text = new TextDecoder('utf-8', { fatal: true }).decode(bytes); } catch (_) { /* denied below */ }
    const hasControls = text && Array.from(text).some(c => { const n = c.charCodeAt(0); return n <= 8 || (n >= 14 && n <= 31); });
    if (!text || hasControls || /^\s*<(?:!doctype|html|script|svg|\?xml)/i.test(text)) {
      throw Object.assign(new Error('PDF, PNG, JPEG, UTF-8 TXT/CSV 파일만 허용합니다.'), { code: 'VALIDATION_ERROR' });
    }
    mime = claimedType === 'text/csv' || /\.csv$/i.test(name) ? 'text/csv' : 'text/plain';
  }
  const normalized = claimedType === 'application/octet-stream' || !claimedType ? mime : claimedType;
  if (normalized !== mime && !(mime.startsWith('text/') && normalized.startsWith('text/'))) {
    throw Object.assign(new Error('선언된 파일 유형과 실제 내용이 일치하지 않습니다.'), { code: 'VALIDATION_ERROR' });
  }
  const safeName = Array.from(String(name || 'attachment')).map(c => c === '/' || c === '\\' || c.charCodeAt(0) <= 31 ? '_' : c).join('').slice(0, 120);
  return { name: safeName, mimeType: mime, size: bytes.length, scanStatus: 'BASIC_VALIDATED', extractedText: mime.startsWith('text/') ? new TextDecoder().decode(bytes).slice(0, 40000) : '' };
}

module.exports = { validateFile, MAX_FILE_BYTES };
